import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenesysEmailAttachmentsComponent } from './genesys-email-attachments.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    GenesysEmailAttachmentsComponent
  ],
  exports: [
    GenesysEmailAttachmentsComponent
  ]
})
export class GenesysEmailAttachmentsModule {}
